import _ from 'lodash';

const MEDIA_QUERIES = {
  mobile: '(max-width: 768px)',
  tablet: '(min-width: 769px) and (max-width: 1024px)',
  desktop: '(min-width: 1025px)'
};

export default function hideOnDevices(devices) {
  if (_.isEmpty(devices)) {
    return '';
  }

  return devices.split(',')
    .filter(device => MEDIA_QUERIES[device])
    .map(device => `@media ${MEDIA_QUERIES[device]} { display: none; }`)
    .join('\n');
}
